import { useAuth } from "./auth";
import { get } from "./AureaApi";
import { getUrl } from "../getUrl";
import { GeoJSONFeatureCollection } from "./api-results.types";
import { GetResultSetLayerParams } from "./route-params.types";

export default async function getResultSetLayer({
  params: { resultSetId },
}: GetResultSetLayerParams): Promise<null | GeoJSONFeatureCollection> {
  return get<GeoJSONFeatureCollection>(`/v1/result_set/${resultSetId}/geojson`);
}

export async function exportToAgromanager(
  resultset_id: string,
): Promise<Response> {
  const token = await useAuth.getState().getToken();
  return await fetch(
    getUrl(`/v1/result_set/${resultset_id}/agromanager_upload`),
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(resultset_id),
    },
  );
}
